import { standardAddApi } from "../../api/standard/standardAddApi"

type PayloadShape = Parameters<typeof standardAddApi>[0]

export async function standardAddService(payload: PayloadShape, token: string) {
	return await standardAddApi(payload, token)
}
